var map = {
	"./CCPH_fillingBlank.json": 6928,
	"./CCPH_multipleChoice.json": 4718,
	"./CCPH_rightWrong.json": 7611,
	"./CCPH_singleChoice.json": 1633,
	"./CCPH_subject.json": 7653,
	"./CMH_fillingBlank.json": 7513,
	"./CMH_multipleChoice.json": 8694,
	"./CMH_rightWrong.json": 702,
	"./CMH_singleChoice.json": 8975,
	"./CMH_subject.json": 8541,
	"./MaoIntro_fillingBlank.json": 8400,
	"./MaoIntro_multipleChoice.json": 5024,
	"./MaoIntro_rightWrong.json": 617,
	"./MaoIntro_singleChoice.json": 3922,
	"./MaoIntro_subject.json": 6848,
	"./Marx_fillingBlank.json": 9683,
	"./Marx_multipleChoice.json": 3874,
	"./Marx_rightWrong.json": 3866,
	"./Marx_singleChoice.json": 5128,
	"./Marx_subject.json": 5632,
	"./NCH_fillingBlank.json": 8931,
	"./NCH_multipleChoice.json": 6721,
	"./NCH_rightWrong.json": 5947,
	"./NCH_singleChoice.json": 5147,
	"./NCH_subject.json": 8542,
	"./ORH_fillingBlank.json": 3321,
	"./ORH_multipleChoice.json": 4391,
	"./ORH_rightWrong.json": 368,
	"./ORH_singleChoice.json": 3000,
	"./ORH_subject.json": 2199,
	"./Political_fillingBlank.json": 9137,
	"./Political_multipleChoice.json": 9556,
	"./Political_rightWrong.json": 6129,
	"./Political_singleChoice.json": 4860,
	"./Political_subject.json": 4556,
	"./SDH_fillingBlank.json": 2415,
	"./SDH_multipleChoice.json": 4659,
	"./SDH_rightWrong.json": 7191,
	"./SDH_singleChoice.json": 2024,
	"./SDH_subject.json": 5584,
	"./XiIntro_fillingBlank.json": 3407,
	"./XiIntro_multipleChoice.json": 2242,
	"./XiIntro_rightWrong.json": 207,
	"./XiIntro_singleChoice.json": 8223,
	"./XiIntro_subject.json": 621,
	"./cura/CCPH_1.json": 8040,
	"./cura/CCPH_10.json": 4799,
	"./cura/CCPH_2.json": 2779,
	"./cura/CCPH_3.json": 7251,
	"./cura/CCPH_4.json": 5368,
	"./cura/CCPH_5.json": 9286,
	"./cura/CCPH_6.json": 1108,
	"./cura/CCPH_7.json": 6206,
	"./cura/CCPH_8.json": 3052,
	"./cura/CCPH_9.json": 6710,
	"./cura/CCPH_residual.json": 6556,
	"./cura/CMH_1.json": 4727,
	"./cura/CMH_10.json": 799,
	"./cura/CMH_11.json": 9364,
	"./cura/CMH_12.json": 3752,
	"./cura/CMH_13.json": 1311,
	"./cura/CMH_14.json": 3405,
	"./cura/CMH_15.json": 5115,
	"./cura/CMH_2.json": 8692,
	"./cura/CMH_3.json": 1856,
	"./cura/CMH_4.json": 2497,
	"./cura/CMH_5.json": 624,
	"./cura/CMH_6.json": 930,
	"./cura/CMH_7.json": 3207,
	"./cura/CMH_8.json": 5558,
	"./cura/CMH_9.json": 4017,
	"./cura/CMH_residual.json": 321,
	"./cura/MaoIntro_1.json": 7058,
	"./cura/MaoIntro_10.json": 5787,
	"./cura/MaoIntro_11.json": 4011,
	"./cura/MaoIntro_12.json": 8657,
	"./cura/MaoIntro_13.json": 7472,
	"./cura/MaoIntro_14.json": 7062,
	"./cura/MaoIntro_15.json": 952,
	"./cura/MaoIntro_16.json": 5568,
	"./cura/MaoIntro_2.json": 4890,
	"./cura/MaoIntro_3.json": 9426,
	"./cura/MaoIntro_4.json": 4676,
	"./cura/MaoIntro_5.json": 4121,
	"./cura/MaoIntro_6.json": 4035,
	"./cura/MaoIntro_7.json": 1085,
	"./cura/MaoIntro_8.json": 1277,
	"./cura/MaoIntro_9.json": 3291,
	"./cura/MaoIntro_residual.json": 4453,
	"./cura/Marx_1.json": 4432,
	"./cura/Marx_2.json": 7627,
	"./cura/Marx_3.json": 3184,
	"./cura/Marx_4.json": 9433,
	"./cura/Marx_5.json": 6210,
	"./cura/Marx_6.json": 323,
	"./cura/Marx_7.json": 4918,
	"./cura/Marx_8.json": 2773,
	"./cura/Marx_residual.json": 7913,
	"./cura/NCH_1.json": 6620,
	"./cura/NCH_2.json": 6684,
	"./cura/NCH_3.json": 8841,
	"./cura/NCH_4.json": 5425,
	"./cura/NCH_5.json": 4172,
	"./cura/NCH_residual.json": 8453,
	"./cura/ORH_1.json": 7686,
	"./cura/ORH_2.json": 4110,
	"./cura/ORH_3.json": 3917,
	"./cura/ORH_4.json": 7267,
	"./cura/ORH_5.json": 3048,
	"./cura/ORH_6.json": 2854,
	"./cura/ORH_7.json": 5785,
	"./cura/ORH_8.json": 5295,
	"./cura/ORH_residual.json": 9455,
	"./cura/Political_1.json": 4602,
	"./cura/Political_10.json": 4021,
	"./cura/Political_11.json": 8422,
	"./cura/Political_12.json": 6763,
	"./cura/Political_2.json": 4286,
	"./cura/Political_3.json": 401,
	"./cura/Political_4.json": 7874,
	"./cura/Political_5.json": 2527,
	"./cura/Political_6.json": 9387,
	"./cura/Political_7.json": 6737,
	"./cura/Political_8.json": 1361,
	"./cura/Political_9.json": 7348,
	"./cura/Political_residual.json": 8428,
	"./cura/SDH_1.json": 3907,
	"./cura/SDH_2.json": 7647,
	"./cura/SDH_3.json": 2272,
	"./cura/SDH_4.json": 6243,
	"./cura/SDH_5.json": 8703,
	"./cura/SDH_6.json": 7356,
	"./cura/SDH_residual.json": 3618,
	"./cura/XiIntro_1.json": 1890,
	"./cura/XiIntro_2.json": 2775,
	"./cura/XiIntro_3.json": 8978,
	"./cura/XiIntro_4.json": 4384,
	"./cura/XiIntro_5.json": 7969,
	"./cura/XiIntro_6.json": 2548,
	"./cura/XiIntro_7.json": 1546,
	"./cura/XiIntro_8.json": 3663,
	"./cura/XiIntro_residual.json": 1906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2609;